import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { Estrategia } from "app/renda-variavel/models/estrategia.model";
import { EstrategiaService } from "app/renda-variavel/services/estrategia.service";
import { Observable } from "rxjs";
import { BaseComponent } from "../../base-module/base-component/base.component";

export interface DialogData {
    id: number;
}

@Component({
    selector: "app-filtro-historico-cliente",
    templateUrl: "./filtro-historico-cliente.component.html",
    styleUrls: ["./filtro-historico-cliente.component.scss"],
    providers: [AtivoService],
})
export class FiltroHistoricoClienteComponent extends BaseComponent {
    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    ativo = new FormControl("");
    operacao = new FormControl("");
    estrategia_id = new FormControl("");
    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);

    paramsStatus: any = {
        finalizada: "",
        tipo: "",
    };

    loadingSpinner!: boolean;
    loadingSpinnerStatus!: boolean;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerAtivos!: boolean;
    loadingSpinnerArquivos!: boolean;
    filteredOptions!: Observable<any[]>;
    listStatus: any[] = [];
    listAssessor: any[] = [];
    listAtivos: any[] = [];
    listArquivos: any[] = [];
    filteredOptionsAtivo!: Observable<any[]>;

    listEstrategia: Estrategia[] = [];
    loadingSpinnerEstrategia!: boolean;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltroHistoricoClienteComponent, { static: false })
    table!: FiltroHistoricoClienteComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltroHistoricoClienteComponent>,
        private _utilitesService: UtilitesService,
        private _ativoService: AtivoService,
        private _serviceEstrategia: EstrategiaService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);

        this.getAllEstrategias();
        this.ativo.valueChanges.subscribe((query) => {
            if (typeof query === "string") {
                this.loadingSpinnerAtivos = true;
                this.params.search = query;
                this.params.tipo = "NORMAL";
                this.filteredOptionsAtivo = this._ativoService.search(
                    this.params
                );
            }
        });
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar(): void {
        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(
                this.data_operacao_inicio.value ?? new Date()
            );
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(
                this.data_operacao_fim.value ?? new Date()
            );
        }

        const ativoSelecionado: any = this.ativo.value;

        this.dialogRef.close({
            data_operacao_inicio: inic,
            data_operacao_fim: fim,
            ativo_id: ativoSelecionado ? ativoSelecionado.id : null,
            estrategia_id: this.estrategia_id.value,
            operacao: this.operacao.value,
        });
    }

    displayFnAtivo(ativo: any): string {
        if (ativo) {
            return ativo.sigla;
        }
        return "";
    }

    getAtivo(ativo: any): void {
        this.loadingSpinnerAtivos = false;
    }

    getAtivos(): void {
        this.loadingSpinnerAtivos = true;
        this._ativoService.getAll({ no_paginate: true }).subscribe(
            (resquest) => {
                this.listAtivos = resquest.data;
            },
            (error) => {
                this.loadingSpinnerAtivos = false;
            },
            () => {
                this.loadingSpinnerAtivos = false;
            }
        );
    }

    getAllEstrategias() {
        this.loadingSpinnerEstrategia = true;
        this._serviceEstrategia.getLista().subscribe(
            (list) => {
                this.listEstrategia = list.data ?? [];
            },
            (error) => { },
            () => {
                this.loadingSpinnerEstrategia = false;
            }
        );
    }
}
